import * as etree from 'elementtree';

export const shiftWidth = (template, fromColumn, count) => {
    const sheet = template.loadSheet(1);
    const fromIndex = template.charToNum(fromColumn) - 1;
    const columns = sheet.root.find('./cols');
    const widths = [];
    columns.getchildren().forEach(c => {
        if (c.attrib.max < 1000) {
            for (let i = c.attrib.min; i <= c.attrib.max; ++i)
                widths.push(+c.attrib.width);
        }
        else
            widths.push(+c.attrib.width);
    });
    const newWidths = widths.slice(0, fromIndex + 1);
    for (let i = 0; i < count; ++i) {
        newWidths.push(widths[fromIndex]);
    }
    newWidths.push(...widths.slice(fromIndex + 1));

    columns.getchildren().forEach(child => columns.remove(child));
    newWidths.forEach((width, index) => {
        const col = etree.SubElement(columns, 'col');
        col.set('min', index + 1);
        col.set('max', index < newWidths.length - 1 ? index + 1 : 16384);
        col.set('width', width);
        col.set('customWidth', '1');
        col.set('bestFit', '1');
    });
    template.archive.file(sheet.filename, etree.tostring(sheet.root));
}